<template>
    <b-card title=" Testeste A/B 🙌">
      <b-card-text>Testeste A/B</b-card-text>
    </b-card>
  </template>
  
  <script>
  import { BCard, BCardText } from 'bootstrap-vue'
  
  export default {
    components: {
      BCard,
      BCardText,
    },
  }
  </script>
  
  <style>
  
  </style>
  